import styled from "styled-components";

interface DefaultCursorProps {}

const Round = styled.div`
  height: 64px;
  width: 64px;
  background-color: ${({ theme }) => theme.colors.hotPink};
  border-radius: 50%;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const DefaultCursor: React.FC<DefaultCursorProps> = ({ children }) => {
  return <Round>{children}</Round>;
};
